import React from 'react';
import { Splitter } from '@progress/kendo-react-layout';
import classNames from 'classnames';
import Router from '../../router/Router';
import Header from './header/Header';
import Footer from './footer/Footer';
import LocalCache from '../../../utility/LocalCache';
import { Component } from '../../../dispatcher/modules';
import Sidebar from './sidebar/Sidebar';
import { Position } from '../../../dispatcher/Types';
import { VIEWPORT_PROPS, VIEWPORT_STATE } from './Types';
// @ts-ignore
import Properties from 'properties';

class Viewport extends Component<VIEWPORT_PROPS, VIEWPORT_STATE> {
  constructor(props: VIEWPORT_PROPS) {
    super(props);

    this.state = {
      panes: [{
        resizable: false
      }]
    };

    // Added to enable pop up message on url redirection
    window.onbeforeunload = function () {
      if (props.preventBrowserPopup) {
        return null;
      }

      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code
      } else {
        // production code
        return '';
      }
    };
  }

  moduleDidMount() {
    document.body.addEventListener('keydown', this.handleKeyDown, true);
    const { IS_NOT_LOGIN_APP } = Properties;
    if (IS_NOT_LOGIN_APP) {
      this.dispatch('redirectTo', Position.end, {
        path: this.props.defaultRoute
      });
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKeyDown, true);
    super.componentWillUnmount();
  }

  /**
   * Keydown handler
   */
  handleKeyDown = (event: KeyboardEvent) => {
    const { keyCode } = event;
    let F4code = 115; // keycode for F4 key
    if (keyCode === F4code) {
      this.focusNextSection();
    }
  };

  /**
   * Focus next section on active page
   */
  focusNextSection = () => {
    let dialogElement = document.body.getElementsByClassName('k-dialog')[0];
    let elementForSearch = dialogElement ? dialogElement : document.body;
    let sections = elementForSearch.getElementsByTagName('section');
    let activeElement = document.activeElement;

    let sectionsLength = sections.length;
    let i = 0;
    let current;
    let activeSectionIndex = null;
    while (i < sectionsLength && activeSectionIndex === null) {
      current = sections[i];
      if (current.contains(activeElement)) {
        activeSectionIndex = i;
      }
      i++;
    }

    let nextSection;
    if (activeSectionIndex === null) {
      nextSection = sections[0];
    } else {
      nextSection = sections[activeSectionIndex + 1];
    }
    if (!nextSection) {
      nextSection = sections[0];
    }

    nextSection?.focus();
  };

  render() {
    const { config, showFooter = true, showSidebar = true, showAddAction = true, headerProps, isSidebarExpandable = false } = this.props;
    const { routesConfig = [], actionsConfig = [] } = config;
    const tpViewportContent = classNames(
      'tp-viewport-content tp-no-border',
      {
        'tp-collapsed': this.state.sideBarCollapsed
      }
    );

    const viewportCls = classNames(
      'tp-viewport',
      {
        'tp-without-footer': !showFooter,
        'tp-without-sidebar': !showSidebar
      }
    );

    return (
      <div className={viewportCls}>
        <header className="tp-100">
          <Header
            projectLogoText={this.props.projectLogoText}
            isLoggingApp={this.props.isLoggingApp}
            themes={this.props.themes}
            {...headerProps}
          />
        </header>
        <Splitter
          panes={this.state.panes}
          className={tpViewportContent}
        >
          {showSidebar ?
            <Sidebar
              showAddAction={showAddAction}
              routesConfig={routesConfig}
              actionsConfig={actionsConfig}
              isExpandable={isSidebarExpandable}
            /> : <></>}
          <main>
            <Router
              config={[...routesConfig, ...actionsConfig]}
              defaultRoute={this.props.defaultRoute}
            />
          </main>
        </Splitter>
        {showFooter ? <footer>
          <Footer
            appName={this.props.appName}
            appVersion={this.props.appVersion}
            sessionsCount={this.props.sessionsCount}
            lastLoginDate={this.props.lastLoginDate}
            serverNode={this.props.serverNode}
          />
        </footer> : null}
      </div>
    );
  }

  private getRedirectTo() {
    let previousRoute = LocalCache.getItem('route');
    return unescape(previousRoute ? previousRoute : this.props.defaultRoute);
  }
}

export default Viewport;
